import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import success from '@/assets/lotties/success.json'
import { Feedback } from '@/components/Feedback/Feedback'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'

export const ImpersonationPaymentSuccess = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <WeScreen useHeader={false}>
      <Feedback
        lottie={success}
        lottieLoop={false}
        title={t('impersonation.paymentSuccess.title')}
        message={t('impersonation.paymentSuccess.message')}
        primaryButtontext={t('impersonation.paymentSuccess.primaryButton')}
        onClickPrimaryButton={() =>
          navigate(AppRoutes.impersonationGeneratingReport)
        }
        secondaryButtontext={t('impersonation.paymentSuccess.secondaryButton')}
        onClickSecondaryButton={() => navigate(AppRoutes.dashboard)}
      />
    </WeScreen>
  )
}
